<template>
  <div class="d-flex gap-2 align-start">
    <v-card
      v-for="(theme, themeKey) in themes"
      :key="themeKey"
      :dark="theme.dark"
      :light="theme.light"
      class="pt-1 pa-2"
      rounded="lg"
      outlined
    >
      <small class="lh-1">{{ theme.label }}:</small>


      <div class="d-flex gap-1" style="height: 24px">
        <v-tooltip
          v-for="(color, colorKey) in colorTypes"
          :key="colorKey"
          :text="color.label"
          top
        >
          <template v-slot:activator="{ on }">
            <v-chip
              v-on="on"
              class="color-square"
              :style="{
                backgroundColor: colors?.[themeKey]?.[colorKey],
                border: '1px solid #c0c1c4',
              }"
            />
          </template>
          <span>{{ color.label }}</span>
        </v-tooltip>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    colors: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    themes: {
      light: { label: "Tema Claro", light: true },
      dark: { label: "Tema Escuro", dark: true },
    },
    colorTypes: {
      primary: { label: "Primária" },
      secondary: { label: "Secundária" },
      brandPrimary: { label: "Marca Primária" },
      brandSecondary: { label: "Marca Secundária" },
    },
  }),
};
</script>

<style scoped>
.color-square {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  cursor: pointer;
}
</style>
